<div class="inner-page-header">
  <h3>اضافة جديدة</h3>
</div>
<div class="new-additions-wrapper">
  <form [formGroup]="additionsFormGroup">
    <div class="main-card">
      <div class="additions d-block">
        <div class="row">
          <div class="col-md-6">
            <app-switch-input
              [label]="'حالة الإضافة'"
              [labelEn]="'is_active'"
              [labelDesc]="'(مفعل/غير مفعل)'"
              [index]="0"
              [value]="isActive"
              (valueChanged)="isActiveValueChanged($event)"
            >
            </app-switch-input>
            </div>
            <div class="col-md-6">
              <app-switch-input
                [label]="'إظهار في ملخص التقرير'"
                [labelEn]="'show_in_report_summary_section'"
                [labelDesc]="'(نعم/لا)'"
                [index]="1"
                [value]="showInReportSummarySection"
                (valueChanged)="isActiveValueChanged($event)"
                  >
              </app-switch-input>
            </div>
          </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label> اسم الإضافة</label>
          <input
            class="form-control"
            type="text"
            formControlName="name"
            placeholder="اسم الإضافة..."
          />
        </div>
        <div class="col-md-6">
          <label>نص توضيحي</label>
          <input
            class="form-control"
            type="text"
            formControlName="description"
            placeholder="نص توضيحي..."
          />
        </div>
      </div>
      <div class="row">
        @if(choices && choices.length > 0) {
        <div class="col-md-6 mt-4">
          <label> حالة إظهار الإضافة </label>
          <app-select
            [optionItems]="choices"
            [placeholder]="'يرجى تحديد حالة ظهور الإضافة '"
            [id]="'choices'"
            [initValues]="InitChoices"
            [maxLength]="2"
            (selectedOptions)="setAdditionChoices($event)"
          >
          </app-select>
        </div>
        }
        <div class="col-md-6 mt-4">
          <label>أنواع الحقول المسموح للفاحص بإضافتها</label>
          <app-select
            [optionItems]="fieldChoices"
            [placeholder]="'يرجى تحديد أنواع الحقول المسموح بها'"
            [id]="'allowed_custom_fields'"
            [initValues]="InitInspectorAdditionChoices"
            [bindLabel]="'text'"
            [maxLength]="2"
            (selectedOptions)="setInspectorAdditionChoices($event)"
          >
          </app-select>
        </div>
      </div>
      <div class="field-main-wrapper">
        @for (item of fields.controls; track item; let i = $index) {
        <div class="field-wrapper" formArrayName="fields">
          <ng-container [formGroupName]="i">
            <div class="field-option checkbox-field">
              <label>افتراضى</label>
              <div class="checkBox-wrapper">
                <label class="checkbox-container">
                  <input type="checkbox" formControlName="is_default" />
                  <span class="checkmark"> </span>
                </label>
              </div>
            </div>
            <div class="field-option">
              <label>اسم الحقل</label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                placeholder="ادخل اسم الحقل ..."
              />
            </div>
            <div class="field-option">
              <label>نوع الحقل </label>
              <ng-select
                bindLabel="name"
                formControlName="type"
                class="single-select"
                placeholder=""
                appendTo="body"
                [searchable]="true"
                (change)="handleTypes($event, i)"
                [clearable]="true"
              >
                @for (field of fieldChoices; track field.id) {
                <ng-option [value]="field.id">
                  {{ field.text }}
                </ng-option>
                }
              </ng-select>
            </div>
            @if([additionalChoicesEnum.Select, additionalChoicesEnum.CheckBox, additionalChoicesEnum.MultiSelect].includes(fields.at(i).get('type').value)){
            <div class="field-option">
              <label> الاختيارات</label>
              <ng-select
                [items]="options[i]"
                bindLabel="text"
                bindValue="id"
                [addTag]="addOptions"
                [multiple]="true"
                (add)="addOption($event, i)"
                formControlName="choices"
                (remove)="onRemove($event, i)"
                placeholder="ادخل الاختيارات..."
              >
              </ng-select>
            </div>
            }
            <div class="actions-wrapper">
              @if (i == 0) {
              <button class="btn btn-add" (click)="addField()">
                <img alt="" src="assets/images/svg/add-service.svg" />
              </button>
              } @else {
              <button class="btn btn-add" (click)="deleteItem(i)">
                <img alt="" src="assets/images/svg/DELETE1.svg" />
              </button>
              }
            </div>
          </ng-container>
        </div>
        }
      </div>
    </div>
    <div class="btn-wrapper">
      @if (errorMsg) {
      <div class="alert-box">
        <img
          src="assets/images/svg/error-icon.svg"
          class="close-alert"
          (click)="closeError()"
          alt=""
        />
        <p class="alert-msg">{{ message }}</p>
      </div>
      }
      <div class="double-action">
        <button
          class="btn btn-green"
          id="saveBtn"
          type="submit"
          (click)="saveAdditions()"
          [disabled]="loadingForm()"
        >
          حفظ
        </button>
      </div>
    </div>
  </form>
</div>
